// File: stacks/workout/app/src/config/workoutOptions.js

// Centralized options for the workout plan generator UI.

// "Train for" — what the session is for (#83 L4). Values are the prompt's
// style keys, so saved profiles and recipes keep working. How the session runs
// is FORMAT_OPTIONS below; Circuit and Functional moved there.
export const WORKOUT_TYPE_OPTIONS = [
  // The two selectors (utils/mixedStyle.js) — Khronos picks the session shape.
  // "mixed" keeps its stored value so saved profiles and recipes still work.
  {
    value: "next",
    label: "What's next",
    description:
      "Picks what your week is missing — strength, hard intervals or cardio — and says why.",
  },
  {
    value: "mixed",
    label: "Surprise me",
    description:
      "A different session shape each time — rotates through ones you haven't done lately.",
  },
  {
    value: "strength",
    label: "Strength",
    description: "Heavy, low-rep work with long rests to get stronger.",
  },
  {
    value: "hypertrophy",
    label: "Hypertrophy",
    description: "Moderate reps close to failure to build muscle.",
  },
  {
    value: "power",
    label: "Power",
    description:
      "Explosive, low-rep work — jumps, throws, and fast lifts with full recovery.",
  },
  {
    value: "hiit",
    label: "Hard intervals",
    description:
      "All-out intervals, or longer hard efforts for aerobic fitness (VO2max).",
  },
  {
    value: "conditioning",
    label: "Conditioning",
    description: "Sustained, repeatable hard efforts to build work capacity.",
  },
  {
    value: "cardio",
    label: "Cardio",
    description: "Mostly easy, conversational aerobic work.",
  },
  {
    value: "flexibility",
    label: "Mobility",
    description:
      "Stretching, foam rolling, and mobility drills to improve range of motion.",
  },
  {
    value: "recovery",
    label: "Active Recovery",
    description:
      "Low-intensity session to aid muscle recovery and reduce soreness.",
  },
];

// "Format" — how the session runs (#83 L4, utils/sessionFormat.js).
export const FORMAT_OPTIONS = [
  {
    value: "auto",
    label: "Auto",
    description:
      "Each goal's usual format, adjusted by your preferences. No faff picks an EMOM or circuit.",
  },
  {
    value: "straight",
    label: "Straight sets",
    description: "All sets of one exercise, resting between them.",
  },
  {
    value: "superset",
    label: "Supersets",
    description: "Pairs of exercises for different muscles, back to back.",
  },
  {
    value: "circuit",
    label: "Circuit",
    description: "Several exercises in a row, then rest, for rounds.",
  },
  {
    value: "emom",
    label: "EMOM",
    description: "Work at the top of every minute (or two), rest with what's left.",
  },
  {
    value: "amrap",
    label: "AMRAP",
    description: "As many rounds as possible in a set time.",
  },
  {
    value: "tabata",
    label: "Tabata",
    description: "8 rounds of 20 s all-out and 10 s rest.",
  },
];

export const FITNESS_LEVEL_OPTIONS = [
  {
    value: "beginner",
    label: "Beginner",
    description: "New to exercise or returning after a long break.",
  },
  {
    value: "intermediate",
    label: "Intermediate",
    description:
      "Consistent with exercise for 6+ months; comfortable with basic movements.",
  },
  {
    value: "advanced",
    label: "Advanced",
    description:
      "Multiple years of consistent, structured training; proficient in complex lifts.",
  },
];

export const SESSION_DURATION_PRESETS = [
  {
    value: 20,
    label: "Express (20 min)",
    description: "A quick, high-intensity session when you're short on time.",
  },
  {
    value: 45,
    label: "Standard (45 min)",
    description: "A balanced and effective workout duration.",
  },
  {
    value: 60,
    label: "Full (60 min)",
    description:
      "A comprehensive session with ample time for warm-up and cool-down.",
  },
  {
    value: 90,
    label: "Extended (90 min)",
    description: "For in-depth strength work or combined training styles.",
  },
];
